// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import packageApi from '~/apis/package';
import { IBodyUpdate, IQueryParamBase } from '~/utils/interface/common';
import {
  CREATE_PACKAGE,
  DELETE_PACKAGE,
  GET_DETAIL_PACKAGE, GET_LIST_ITEM_OPTIONAL_PACKAGE,
  GET_LIST_PACKAGE,
  UPDATE_PACKAGE,
} from '~/utils/constants/actionType';
import { IQueryParamListItemPackageOption } from '~/utils/interface/package';

export const getListPackage = createAsyncThunk(
  GET_LIST_PACKAGE,
  async (params: IQueryParamBase, { rejectWithValue }) => {
    try {
      const resp = await packageApi.getListPackage(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getDetailPackage = createAsyncThunk(GET_DETAIL_PACKAGE, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await packageApi.getDetailPackage(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createPackage = createAsyncThunk(CREATE_PACKAGE, async (formData: FormData, { rejectWithValue }) => {
  try {
    const resp = await packageApi.createPackage(formData);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deletePackage = createAsyncThunk(DELETE_PACKAGE, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await packageApi.deletePackage(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updatePackage = createAsyncThunk(
  UPDATE_PACKAGE,
  async (params: IBodyUpdate<FormData>, { rejectWithValue }) => {
    try {
      const resp = await packageApi.updatePackage(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getListItemOptionalPackage = createAsyncThunk(
  GET_LIST_ITEM_OPTIONAL_PACKAGE,
  async ({ packageId, params }: {
    packageId: string;
    params: IQueryParamListItemPackageOption
  }, { rejectWithValue }) => {
    try {
      const resp = await packageApi.getListItemOptionalPackage(packageId, params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
